'use client';

import { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useRequestPasswordResetOtp } from '@/lib/hooks/useAuth';
import { ArrowLeft } from 'lucide-react';

export default function ForgotPasswordForm() {
  const router = useRouter();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errors, setErrors] = useState<{ phone?: string }>({});

  const requestOtpMutation = useRequestPasswordResetOtp({
    onSuccess: () => {
      router.push(`/forgot-password/verify?phone=${encodeURIComponent(phoneNumber.trim())}`);
    },
  });

  const validateForm = () => {
    const newErrors: { phone?: string } = {};
    if (!phoneNumber.trim()) {
      newErrors.phone = 'Vui lòng nhập số điện thoại';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (requestOtpMutation.isPending) return;
    if (!validateForm()) return;
    setErrors({});
    requestOtpMutation.mutate({ phone: phoneNumber.trim() });
  };

  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Quên mật khẩu</h1>
        <p className="text-sm text-gray-500">
          Nhập số điện thoại đã đăng ký, chúng tôi sẽ gửi mã OTP qua Zalo để đặt lại mật khẩu.
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="phone_number" className="block text-sm font-medium text-gray-700 mb-2">
            Số điện thoại
          </label>
          <input
            id="phone_number"
            type="text"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
              if (errors.phone) setErrors({ ...errors, phone: undefined });
            }}
            placeholder="Nhập số điện thoại"
            className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
              errors.phone ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-white hover:border-gray-400'
            }`}
            disabled={requestOtpMutation.isPending}
          />
          {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
        </div>

        <button
          type="submit"
          disabled={requestOtpMutation.isPending}
          className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {requestOtpMutation.isPending ? 'Đang gửi mã...' : 'Gửi mã OTP'}
        </button>
      </form>

      {/* Footer */}
      <div className="mt-6 text-center">
        <Link
          href="/login"
          className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          <ArrowLeft className="w-4 h-4" />
          Quay lại đăng nhập
        </Link>
      </div>
    </div>
  );
}
